import { getWorkdayEmployeeUpdateFailures } from '../api'
import { workdayEmployeeUpdateFailuresKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useWorkdayEmployeeUpdateFailures = () => {
  return useQuery(workdayEmployeeUpdateFailuresKeys.all, () =>
    getWorkdayEmployeeUpdateFailures(),
  )
}
